import styled from "styled-components/macro"
import { mobile } from "../styles/responsive"

export const Container = styled.div``
export const Wrapper = styled.div`
  width: 60%;
  min-height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  margin: 20px auto;
  ${mobile({ width: "75%", height: "100%" })}
`
export const Title = styled.h1`
  margin-bottom: 30px;
  text-align: center;
`
export const Form = styled.form`
  width: 500px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border: 1px solid black;
  border-radius: 20px;
  padding: 30px 20px;
  ${mobile({ width: "100%" })}
`
export const Input = styled.input`
  width: 200px;
  margin: 10px 0;
  padding: 10px;
  border-radius: 20px;
  margin-left: 10px;
  ${mobile({ width: "100%" })}
`
export const Button = styled.button`
  margin: 20px 0 10px 0;
  padding: 10px;
  border-radius: 20px;
  background-color: #4c87ef;
  color: white;
  cursor: pointer;

  &:hover {
    background-color: #6395eb;
  }
  &:disabled {
    color: lightgray;
    cursor: not-allowed;
  }
`
export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
`
